// - The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// Check for auth token in cookies and restore it to localStorage if found
(function() {
  const getCookie = function(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };

  const authToken = getCookie('auth_token');
  if (authToken && !localStorage.getItem('default-auth-token')) {
    localStorage.setItem('default-auth-token', authToken);
  }
})();

import Vue from 'vue'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { ApolloLink, concat } from 'apollo-link'
import { InMemoryCache } from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'
import App from './App'
import router from './router'
import store from './store'
import VueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import VueFire from 'vuefire'
import * as filters from './utils/filters'
import * as VueGoogleMaps from 'vue2-google-maps'
import VTooltip from 'v-tooltip'
import ToggleButton from 'vue-js-toggle-button'
import { Name } from '../public/my.env'
import Tabs from 'vue-tabs-component'

Vue.use(Tabs)
Vue.use(VTooltip)
Vue.use(ToggleButton)
Vue.config.productionTip = false

Object.keys(filters).forEach(filterName => {
  Vue.filter(filterName, filters[filterName])
})
Vue.prototype.$isStage = 0
Vue.prototype.$fbDbEntry = 'racers'
/* Check if status is Live/Staging */
const status = window.localStorage.getItem('envStatus')
if(status){
  Vue.prototype.$envStatus = status
}else{
  Vue.prototype.$envStatus = 'Staging'
}

const distanceIn = window.localStorage.getItem('distanceIn')
if(distanceIn){
  Vue.prototype.$envdistanceIn = distanceIn
}else{
  Vue.prototype.$envdistanceIn = 'Km'
}


if(window.location.protocol === 'https:' && Name === 'st6'){
  Vue.prototype.$expressApi = window.location.protocol+'//trainerapi-s1.liverunapp.com:3107/'
}else if(window.location.protocol === 'http:' && Name === 'st6'){
  Vue.prototype.$expressApi = window.location.protocol+'//trainerapi-s1.liverunapp.com:3007/'
}

if(window.location.protocol === 'https:' && Name === 'st5'){
  Vue.prototype.$expressApi = window.location.protocol+'//trainerapi-s.liverunapp.com:3105/'
}else if(window.location.protocol === 'http:' && Name === 'st5'){
  Vue.prototype.$expressApi = window.location.protocol+'//trainerapi-s.liverunapp.com:3005/'
}

if(window.location.protocol === 'https:' && Name === 'st4'){
  Vue.prototype.$expressApi = window.location.protocol+'//trainerapi.liverunapp.com:3104/'
}else if(window.location.protocol === 'http:' && Name === 'st4'){
  Vue.prototype.$expressApi = window.location.protocol+'//trainerapi.liverunapp.com:3004/'
}

// Local development environment
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
  Vue.prototype.$expressApi = 'http://localhost:4000/'
  console.log('Using local API endpoint:', Vue.prototype.$expressApi)
}

Vue.use(VueResource)
Vue.use(VeeValidate)
Vue.use(VueFire)

Vue.use(VTooltip)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDe44Xq6yp5JFV21V4AJr_i3uaGo4jlX6U',
    v: '3.36',
  }
})
console.log(process.env.API)
Vue.http.options.root = process.env.API

Vue.router = router

Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/vue-resource.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  rolesVar: 'role',
  loginData: {url: 'authenticate?panel-trainer', method: 'POST', redirect: '/', fetchUser: true},
  fetchData: {url: 'account', method: 'GET'},
  refreshData: {url: 'api/auth/refresh', method: 'GET', enabled: false},
  parseUserData: (data) => {
    return data || {}
  }
})


// var graphglLink = ''
// console.log(" Vue.prototype.$envStatus---", Vue.prototype.$envStatus)
// if(Vue.prototype.$envStatus == 'Live'){
//   graphglLink= 'http://localhost:4000/graphql'
// }else{
//   graphglLink= 'https://gql.liverunapp.com/graphql'
// }

// const httpLink = new HttpLink({
//   uri: graphglLink
// })

const httpLink = new HttpLink({
  uri: 'https://gql-liverun.npit.pw/graphql'
})

const token = window.localStorage.getItem('default-auth-token') || null
const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      authorization: `Bearer ${token}`
    }
  })
  return forward(operation)
})

const apolloClient = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache: new InMemoryCache(),
  connectToDevTools: true
})

Vue.use(VueApollo)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  apolloProvider,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js